import HeaderMenuActionTypes from 'common/components/headerMenu/enums/HeaderMenuActionTypes';

const USER_MANAGEMENT_ACTIONS: HeaderMenuActionTypes[] = [
  HeaderMenuActionTypes.Users,
  HeaderMenuActionTypes.Roles,
];

export default USER_MANAGEMENT_ACTIONS;
